import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { FlashMessage } from '@treatwell/treatwell-aura';
import { BusinessType } from './input';
import { Form, Title } from './templates';

export function StepThreeForm() {
  const { t } = useTranslation('stepThreeForm');
  const [error, setError] = useState<string | null>(null);

  return (
    <Form>
      {error && (
        <FlashMessage
          message={error}
          flavor="error"
          onDismiss={() => setError(null)}
        />
      )}
      <Title text={t('title')} showStepCounter />
      <BusinessType onError={setError} />
    </Form>
  );
}
